import React, { useState, useEffect, useRef } from 'react';
import { Scroll, closest, isTouch, filter, findIndex } from 'helpers';
import { mount } from './mount';
import * as css from 'styles/blocks/testimonials.scss';

export const Testimonials = mount(!isTouch() && 'app-testiomonials', props => {

  const container = useRef();
  const rotationInterval = 5000;
  const [ testimonials, setTestiomonials ] = useState();
  const [ scroller, setScroller ] = useState();
  const [ current, setCurrent ] = useState();
  const [ interval, saveInterval ] = useState();

  //initialize - setup scroller and testimonial items
  useEffect(() => {
    setScroller(new Scroll({
      horizontal: true,
      vertical: false,
      duration: 500,
    }, container.current))
    setTestiomonials(filter(container.current.childNodes, 'tagName'));
  }, []);

  //when we have scroller - start
  useEffect(() => {
    if (scroller) {
      setOffset();
      setCurrent(0);
      saveInterval(window.setInterval(rotate, rotationInterval));
      window.addEventListener('resize', setOffset);
      return () => window.removeEventListener('resize', setOffset);
    }
  }, [ scroller ]);

  //clean up interval
  useEffect(() => () => window.clearInterval(interval), [ interval ]);

  useEffect(() => {
    //scroll to current item
    if (current !== undefined) {
      scroller.toElement(testimonials[current]);
      testimonials.forEach((testimonial, index) => {
        testimonial.classList.toggle(css.next, index > current);
        testimonial.classList.toggle(css.prev, index < current);
        testimonial.classList.toggle('current', index == current);
      });
    }
  }, [ current ]);

  function rotate() {
    const current = findIndex(testimonials, testimonial => testimonial.classList.contains('current'));
    const next = current + 1;
    setCurrent(next >= testimonials.length ? 0 : next);
  }

  function setOffset() {
    const offset = (window.innerWidth - testimonials[0].offsetWidth)/2;
    container.current.style.paddingLeft = offset + 'px';
    scroller.update({ offset: -offset });
  }

  function onClickInside({ target }) {
    const testimonial = closest(target, `.${css.testimonial.replace(/ .*/, '')}`);
    if (testimonial) setCurrent(testimonials.indexOf(testimonial));
  }

  return (
    <div
      ref={container}
      className={css.desktopTestimonials}
      dangerouslySetInnerHTML={{ __html: getInnerHTML(props) }}
      onClick={onClickInside}
      onMouseEnter={() => saveInterval(0)}
      onMouseLeave={() => saveInterval(window.setInterval(rotate, rotationInterval))}
    />
  );
});

function getInnerHTML({ innerHTML }) {
  //remove <div> wrapper
  innerHTML = innerHTML.replace(/^<div.*?>/, '');
  innerHTML = innerHTML.replace(/<\/div>\s*$/, '');
  return innerHTML;
}
